import React from "react";
import { Urls } from "../../constants/UrlConstants";

let nullLoggedOutContent = {
  heading: "You've successfully logged out.",
  subHeading1: "See you next time.",
  subHeading2: "",
  paragraph1: "",
  paragraph2: "",
  subHeading3: ""
};

let standardLoggedOutContent = {
  heading: "You've successfully logged out.",
  //heading: "You are now logged out",
  subHeading1: "Let us know what you think...",
  subHeading2: "We’d love to know what you think",
  paragraph1:
    "We’d really like to hear about your online experience today. Click continue to take part in a short survey to help us improve our service. There are only 4 questions and they shouldn’t take more than 5 minutes to answer.",
  paragraph2: (
    <React.Fragment>
      All data will be kept anonymous. If you’d like to know more about our data
      protection policy, please visit our{" "}
      <a href={Urls.PrivacyUrl.MOL} target="_blank" rel="noopener noreferrer">
        <u>privacy policy</u>
      </a>
      . This research is conducted in accordance with the MRS Code of Conduct.
    </React.Fragment>
  ),
  subHeading3: "Would you like to tell us what you think?"
};

let internationalLoggedOutContent = Object.assign({}, standardLoggedOutContent);
internationalLoggedOutContent.subHeading2 =
  "We'd really like to hear what you think of your online service.";
internationalLoggedOutContent.paragraph1 =
  "Could you spare a few moments to answer 4 questions?";
delete internationalLoggedOutContent.paragraph2;

let HOLLoggedOutContent = Object.assign({}, standardLoggedOutContent);
HOLLoggedOutContent.paragraph1 = "Click Continue to take part in the survey.";
HOLLoggedOutContent.paragraph2 =
  "By clicking Continue, you agree to participate in the survey by Health-on-Line to help improve their service. The survey should take about 5 minutes for you to complete, depending on your answers.";
HOLLoggedOutContent.paragraph3 = (
  <React.Fragment>
    All data will be kept in the strictest confidence. If you would like any
    further details concerning data protection, please visit{" "}
    <a href={Urls.PrivacyUrl.HOL} target="_blank" rel="noopener noreferrer">
      www.health-on-line.co.uk/site-services/privacy-legal-cookies
    </a>
    .
  </React.Fragment>
);

export default {
  main: {
    MOL: nullLoggedOutContent,
    International: internationalLoggedOutContent,
    // HOL: HOLLoggedOutContent
    HOL: nullLoggedOutContent,
  },
  returnToLoginButton: {
    label: "Back to login"
  },
  noThanksButton: {
    label: "no thanks"
  },
  continueButton: {
    label: "continue to survey"
  },
  pageTitle: "Logged out"
};
